import { render } from "./MedicationInstruction.vue?vue&type=template&id=f05b0532"
import script from "./MedicationInstruction.vue?vue&type=script&lang=js"
export * from "./MedicationInstruction.vue?vue&type=script&lang=js"

import "./MedicationInstruction.vue?vue&type=style&index=0&id=f05b0532&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__